// src/components/DataImport/useSpreadsheetParser.ts
import { useState } from "react";
import * as XLSX from "xlsx";

export interface ParsedSheetRow {
  id: number;
  [key: string]: any;
}

export const useSpreadsheetParser = () => {
  const [data, setData] = useState<ParsedSheetRow[]>([]);
  const [columns, setColumns] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const parseFile = async (file: File) => {
    setLoading(true);
    try {
      const arrayBuffer = await file.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json<Record<string, any>>(sheet, { defval: "" });

      const cols = json.length > 0 ? Object.keys(json[0]) : [];
      const formatted = json.map((row, i) => ({ id: i + 1, ...row }));

      setColumns(cols);
      setData(formatted);
      return { data: formatted, columns: cols };
    } finally {
      setLoading(false);
    }
  };

  return { data, columns, loading, parseFile };
};
